import { Flyout } from "@omni/components/components/General/Flyout/flyout";
import { Sidebar } from "@omni/components/components/Navigation/Sidebar/sidebar";
import { getTagZoneIdFor } from "@omni/components/utils/tagging/tag.utils";
import { cn } from "@omni/utils/styles";

export const SidebarComponent = () => {
    const { open, subCategoriesActive, onClose } = Sidebar.useContext();

    return (
        <Flyout
            open={open}
            onClose={onClose}
            overlayHeader={false}
            className={cn("tw:overflow-hidden tw:relative")}
        >
            <Flyout.Content
                className={cn(
                    // DONT REMOVE - This class is used to style the via parents
                    "sidebar",
                    "tw:p-0 tw:overflow-x-hidden tw:relative",
                    {
                        "tw:overflow-y-hidden": subCategoriesActive,
                        "tw:overflow-y-auto": !subCategoriesActive
                    }
                )}
                {...getTagZoneIdFor("flyout-menu-mobile")}
            >
                <Sidebar.Assortiment.Trigger />
                <Sidebar.Assortiment.RootCategory>
                    <Sidebar.Assortiment.CategoryLinks>
                        <Sidebar.Assortiment.CategoryLinks.Link
                            className={cn("tw:pl-12")}
                        />
                    </Sidebar.Assortiment.CategoryLinks>
                </Sidebar.Assortiment.RootCategory>
                <Sidebar.Assortiment.SubCategories>
                    <Sidebar.Assortiment.CategorySlide>
                        <Sidebar.Assortiment.CategorySlide.Back />
                        <Sidebar.Assortiment.CategorySlide.Header />
                        <div
                            className={cn(
                                "tw:flex tw:flex-col tw:overflow-auto"
                            )}
                        >
                            <Sidebar.Assortiment.CategoryLinks>
                                <Sidebar.Assortiment.CategoryLinks.Link />
                            </Sidebar.Assortiment.CategoryLinks>
                        </div>
                    </Sidebar.Assortiment.CategorySlide>
                </Sidebar.Assortiment.SubCategories>
                <Sidebar.InnerHtml className={cn("tw:pl-4")} />
                <Sidebar.AccountLinks />
                <Sidebar.LanguageSelector />
            </Flyout.Content>
            <Flyout.Controls>
                <Flyout.Controls.CloseButton />
            </Flyout.Controls>
        </Flyout>
    );
};
